import DialogComponent from "components/Dialog";
import Select from "components/Select";

export default class signDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            certificates: [],
            selectedSign: false,
            operationId: false,
            showProgress: false,
            step: 1,
        };

        this.state = { ...this.defaultState };
    }

    title = "Подпись врача";

    show(info, hideCb) {
        this.info = info;
        this.hidCb = hideCb;
        this.dialogSaveLabel = "Подписать";

        super.show();
    }

    onShowProgress(id) {
        this.changeState("showProgress", id);
    }

    onHideProgress() {
        this.changeState("showProgress", false);
    }

    async getListCertificates(id) {
        this._helper.showLoading();
        this.onShowProgress(id);
        let resp = await this._request.egisz.listSignCertificates();
        this._helper.hideLoading();
        this.onHideProgress();

        if (resp.code === "internal_error")
            resp = await this.getListCertificates(id + 1);

        return resp;
    }

    async onShow() {
        const resp = await this.getListCertificates(1);
        const certificates = (resp?.data || []).map(it => {
            return {
                id: it.id,
                name: it.dname
            };
        });
        this.setState({ certificates });
    }

    async prepareSing() {
        const { selectedSign } = this.state;
        const { id } = this.info;
        this._helper.showLoading();
        const respPrepare = await this._request.egisz.prepareSign(id, selectedSign);
        const { operationId } = (respPrepare.data || {});
        this._helper.hideLoading();
        return operationId;
    }

    async save() {
        const { operationId, step } = this.state;

        if (step === 1) {
            const opId = await this.prepareSing();
            this.dialogSaveLabel = "Подпись подтверждена";

            this.setState({ step: 2, operationId: opId });
        } else {
            if (operationId === false || operationId === undefined)
                return;

            if (this.hidCb?.apply)
                this.hidCb(this.info, operationId);

            this.hide();
        }
    }

    renderSign() {
        const { certificates, selectedSign, showProgress } = this.state;

        return (
            <div className="shiftsDelDialog">
                {showProgress && <div className="text p1" style={{ marginBottom: "20px" }}>
                    {`Получение списка подписей... Попытка №${showProgress}`}
                </div>}
                <div style={{ marginBottom: "20px" }}>
                    <Select
                        showLeftIcon={false}
                        value={selectedSign}
                        label={"Выберите подпись"}
                        translate={true}
                        items={certificates}
                        onChange={this.changeState.bind(this, "selectedSign")} />
                </div>
            </div>
        );
    }

    renderContent() {
        const { step } = this.state;

        return (step === 2 ? <div className="text p1" style={{ width: "300px", padding: "16px 0" }}>
            Для подтверждения подписи вам нужно зайти в приложение на вашем мобильном телефоне и нажать подтвердить.
        </div> : this.renderSign());
    }
}
